import './form.less';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import InputField from '../../shared/form-elements/input';
import ModalBox from '../../shared/modal';

const Form = ({
	handleSubmit,
	submitForm,
	editId,
	updateConfig,
	dashboardConfigFields,
	intl,
	can
}) => (
	<div className="form-container">

		<div className="form-container__body promo-codes-form">
			<form className="ui-form" onSubmit={handleSubmit(data => submitForm(data, editId))}>

				<div className="ui-form__element">
					<Field
						name="title"
						placeholder={intl('Promo code')}
						component={InputField}
					/>
				</div>

				<div className="ui-form__element">
					<Field
						name="bonus_percent"
						type="number"
						placeholder={intl('Bonus percent')}
						component={InputField}
					/>
				</div>

				<div className="ui-form__element buttons">
					<button className="ui-btn ui-btn-primary">
						{intl('Save')}
					</button>
				</div>
			</form>
		</div>
	</div>
);

const Main = props =>
	<ModalBox
		title={props.intl('Create new promo code')}
		body={Form(props)}
		isOpen={props.isFormOpen}
		onClose={props.toggleForm}
		className='form-modal'
	/>;

export default reduxForm({
	form: 'promoCodesForm'
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/promo-codes/components/form.js